import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable, Injector } from '@angular/core'
import { Observable, tap } from 'rxjs'
import { VarietyErpDataService } from './variety-erp-data.service'

/** Escrituras del ERP que mueven stock (ventas, compras, traspasos, inventario, mermas, fabricación). */
const STOCK_WRITE = /\/v1\/erp\/(sale|purchase|transfer|inventory|waste|manufacturing|planning)\b/i
/** Escrituras de precios. */
const PRICE_WRITE = /\/v1\/erp\/varietyPrice\b/i
/** Lecturas que van por POST (lista de uids en el cuerpo): no invalidan nada. */
const READ_BY_POST = /\/getByVarieties\b/i

/**
 * Descarta la caché de VarietyErpDataService tras una escritura exitosa en el ERP que cambie stock o precios, para que
 * la próxima pantalla no muestre datos viejos. Un solo punto en vez de invalidar a mano en cada servicio.
 */
@Injectable()
export class ErpCacheInvalidationInterceptor implements HttpInterceptor {
    // Se resuelve al usarlo: inyectarlo en el constructor cierra un ciclo (HttpClient → interceptores → este →
    // VarietyErpDataService → HttpClient) y la app no arranca.
    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const write = req.method !== 'GET' && req.method !== 'HEAD' && !READ_BY_POST.test(req.url)
        const stock = write && STOCK_WRITE.test(req.url)
        const prices = write && PRICE_WRITE.test(req.url)
        if (!stock && !prices) return next.handle(req)

        return next.handle(req).pipe(
            tap((event) => {
                if (!(event instanceof HttpResponse) || !event.ok) return
                const erpData = this.injector.get(VarietyErpDataService)
                if (stock) erpData.invalidateInventories()
                if (prices) erpData.invalidatePrices()
            })
        )
    }
}
